import { render, staticRenderFns } from "./specialHome2.vue?vue&type=template&id=434e2ee7&scoped=true"
import script from "./specialHome2.vue?vue&type=script&lang=js"
export * from "./specialHome2.vue?vue&type=script&lang=js"
import style0 from "./specialHome2.vue?vue&type=style&index=0&id=434e2ee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434e2ee7",
  null
  
)

export default component.exports